import actions from './actions'

export default function ContactPersonsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_CONTACTPERSON:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_CONTACTPERSON:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_CONTACTPERSON:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_CONTACTPERSON:
      return {
        ...state,
        editing: { ContactPersonID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_CONTACTPERSON_RECIEVED ||
      actions.UPDATE_CONTACTPERSON_RECIEVED ||
      actions.DELETE_CONTACTPERSON_RECIEVED:
      return {
        ...state,
        editing: { ContactPersonID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    case actions.SAVE_CONTACTPERSON_RECIEVED: {
      return {
        ...state,
        loading: false,
        saveSuccess: true,
        message: action.message,
        savedContactPersonID: action.result.value,
      }
    }
    default:
      return state
  }
}
